module.exports = __webpack_public_path__ + "static/media/prouctImg.a038c40b.png";